import React from 'react';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import CommonStrings from 'resources/common-strings';

export default CreateReactClass({
    displayName: 'ConditionalGrowthIndexWarning',

    propTypes: {
        message: PropTypes.string,
        dismissedYn: PropTypes.bool.isRequired,
        onDismiss: PropTypes.func.isRequired,
    },

    render() {
        const showMessage = this.props.message && !this.props.dismissedYn;
        const className = `cgi-warning${showMessage ? ' show-warning' : ''}`;

        return (
            <div className={className} key="cgi-warning">
                <i className="icon icon-nwea-info-icon" key="cgi-warning-info-icon" />
                <p key="cgi-warning-message">{this.props.message}</p>
                <span key="cgi-warning-collapse-icon" onClick={this.props.onDismiss}>
                    {CommonStrings.collapse}
                </span>
            </div>
        );
    },
});
